/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FC, Ref } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
import type { IntlShapeV2 } from '@atlassian/jira-intl';
import ProjectBreadcrumb from './view.tsx';
import type { ProjectBreadcrumbProps } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { type ProjectBreadcrumbProps } from './types';
const ExportedComponent: FC<
	Pick<
		Omit<
			ProjectBreadcrumbProps & {
				intl: IntlShapeV2;
			},
			'intl'
		>,
		keyof ProjectBreadcrumbProps
	> & {} & {} & {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		forwardedRef?: Ref<any>;
	}
> & {
	defaultProps?: undefined;
} = injectIntl(ProjectBreadcrumb);
export default ExportedComponent;
